<template>
  <div class="home-page">
    <!-- Header / Hero -->
    <header class="home-header">
      <div class="home-topbar">
        <AccountQuickNav />
      </div>
      <h1 class="app-title">
        <img src="@/assets/bible-plan-generator-logo.png" alt="Bible Plan Generator" class="logo-img" />
      </h1>
      <p class="app-subtitle">Generate a custom plan or choose from curated paths.</p>
      
      <div class="header-controls">
         <div class="mode-toggle">
             <button class="toggle-btn" :class="{ active: mode === 'predefined' }" @click="mode = 'predefined'">Curated Plans</button>
             <button class="toggle-btn" :class="{ active: mode === 'custom' }" @click="mode = 'custom'">Generator</button>
         </div>
         
         <div class="translation-select">
            <select v-model="currentTranslation" @change="updateTranslation">
                <option value="KJV">KJV (AV)</option>
                <option value="ESV">ESV</option>
                <option value="NKJV">NKJV</option>
                <option value="NIV">NIV</option>
            </select>
         </div>
      </div>
    </header>

    <!-- CONTENT -->
    <main class="home-content">
        <v-slide-y-transition mode="out-in">
            <!-- Custom Generator -->
            <div v-if="mode === 'custom'" key="custom" class="custom-section">
                <CustomPlanGenerator />
            </div>

            <!-- Predefined Plans -->
            <div v-else key="predefined" class="predefined-section">
                <PredefinedPlanFilters @update:filters="updateFilters" />
                <PredefinedPlanCards :filters="activeFilters" />
            </div>
        </v-slide-y-transition>
    </main>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useUserPreferencesStore } from '../stores/userPreferences';
import CustomPlanGenerator from '../components/CustomPlanGenerator.vue';
import PredefinedPlanFilters from '../components/PredefinedPlanFilters.vue';
import PredefinedPlanCards from '../components/PredefinedPlanCards.vue';
import AccountQuickNav from '../components/AccountQuickNav.vue';

export default {
  name: 'HomePage',
  components: {
    CustomPlanGenerator,
    PredefinedPlanFilters,
    PredefinedPlanCards,
    AccountQuickNav
  },
  setup() {
    const prefsStore = useUserPreferencesStore();
    const mode = ref('predefined');
    const activeFilters = ref({});

    const currentTranslation = computed({
        get: () => prefsStore.translation,
        set: (val) => prefsStore.setTranslation(val)
    });

    const updateFilters = (filters) => {
        activeFilters.value = filters;
    };

    const updateTranslation = () => {
        // Triggered by v-model setter
    };

    return {
        mode,
        currentTranslation,
        activeFilters,
        updateFilters,
        updateTranslation
    }
  }
}
</script>

<style scoped>
.home-page {
    /* Layout */
}

.home-header {
    text-align: center;
    margin-bottom: 40px;
    padding-bottom: 30px;
    border-bottom: 1px solid rgba(119, 124, 124, 0.2);
}

.home-topbar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 30px;
    gap: 12px;
}



.app-title {
    margin-bottom: 8px;
    display: flex;
    justify-content: center;
}

.logo-img {
    height: 120px;
    width: auto;
    max-width: 100%;
    object-fit: contain;
}

.app-subtitle {
    color: #888;
    font-size: 1.1rem;
    margin-bottom: 24px;
}

.header-controls {
    display: flex;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;
}

@media (max-width: 720px) {
    .home-topbar {
        flex-direction: column;
    }
}

.mode-toggle {
    display: flex;
    background: rgba(255,255,255,0.05);
    padding: 4px;
    border-radius: 8px;
}

.toggle-btn {
    padding: 8px 16px;
    background: transparent;
    border: none;
    color: #aaa;
    cursor: pointer;
    font-weight: 600;
    border-radius: 6px;
    transition: all 0.2s;
}

.toggle-btn.active {
    background: rgb(var(--v-theme-primary));
    color: #1f2121;
}

.translation-select select {
    background: #0f1111;
    color: #fff;
    border: 1px solid #333;
    padding: 8px 12px;
    border-radius: 8px;
    cursor: pointer;
    appearance: none; /* Remove default arrow */
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url('data:image/svg+xml;utf8,<svg fill="white" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>');
    background-repeat: no-repeat;
    background-position: right 8px center;
    padding-right: 32px;
}

.translation-select select option {
    background: #0f1111;
    color: #fff;
    padding: 10px;
}
</style>
